// frontend/src/components/entry/EntryBackdrop.jsx
//
// The frame every entry screen (`entryScreen.js`) stands in front of: the
// app's own sidebar and top bar with an empty page, `inert` so nothing
// behind the popup can be clicked or focused. The popup itself is an
// `EntryDialog`, which MUI renders over the frame on its own backdrop. The
// merchant sees the app they are about to enter, not a blank page.
//
// The top bars (and the phone's tab bar, empty) are drawn here, not mounted:
// the live TopMenu polls notifications for the store (`useNotifications`) and
// puts its keyboard shortcuts on `document`, outside this frame, so an inert
// wrapper would not hold them. The sidebar has neither and is the real one, so its links
// and sections never drift from the app's.

import { ICON, MenuIcon } from '../../icons';
import { TabsProvider } from '../../tabs/TabsProvider';
import Sidebar from '../layout/Sidebar';
import { TopMenuLogo } from '../layout/TopMenu';
import '../layout/AppLayout.css';
import '../layout/mobile/MobileChrome.css';

export default function EntryBackdrop({ children }) {
  return (
    <>
      <div className="app-wrapper" inert data-testid="entry-backdrop">
        <TabsProvider>
          <Sidebar />
        </TabsProvider>
        <nav className="top-menu">
          <div className="top-menu-left">
            <span className="top-menu-sidebar-toggle">
              <MenuIcon size={ICON.lg} />
            </span>
            <div className="top-menu-logo-block">
              <TopMenuLogo />
            </div>
          </div>
        </nav>
        <header className="mobile-top-bar mobile-top-bar--logo">
          <TopMenuLogo mobile />
        </header>
        <main className="main-content" />
        <div className="mobile-tab-bar" />
      </div>
      {children}
    </>
  );
}
